import { FilterConfig } from 'components/tables/list-table/ListTableTypes.tsx';
import React, { useCallback, useMemo } from 'react';
import TasksTable from '../../tasks/TasksTable.tsx';

interface Props {
    /** Not read: colours come from the tokens. */
    theme?: unknown;
    matterId?: string;
    clientPartyId?: string;
    correspondenceId?: string;
    debriefingId?: string;
}

const TasksView: React.FC<Props> = ({ matterId, clientPartyId, correspondenceId, debriefingId }) => {
    const getPassiveFilter = useCallback(() => {
        if (matterId) {
            return `taskMatters.matter.id==${matterId}`;
        } else if (clientPartyId) {
            return `clientParties.id==${clientPartyId}`;
        } else if (correspondenceId) {
            return `taskCorrespondence.correspondence.id==${correspondenceId}`;
        } else if (debriefingId) {
            // Custom task-only RSQL operator; Task has no debriefing association path.
            return `id=hasdebriefing=${debriefingId}`;
        }
    }, [clientPartyId, matterId, correspondenceId, debriefingId]);

    const filterConfig: FilterConfig = useMemo(
        () => ({
            quickFilters: [],
            filters: [],
            searchBarSelectors: [
                { selector: 'name' },
                { selector: 'clientParties.name' },
                { selector: 'taskEmployees.employee.fullName' },
            ],
            passiveFilter: getPassiveFilter(),
        }),
        [getPassiveFilter]
    );

    if (!matterId && !clientPartyId && !correspondenceId && !debriefingId) {
        return null;
    }

    return (
        <div className="flex h-full flex-col gap-4">
            <TasksTable
                filterConfig={filterConfig}
                initialSearchParams={''}
                matterId={matterId}
                correspondenceId={correspondenceId}
                clientPartyId={clientPartyId}
                debriefingId={debriefingId}
                canRememberFilters={false}
            />
        </div>
    );
};

export default TasksView;
